export default __webpack_public_path__ + "static/impact_banner-5acc01383cdf493d5d111f97a10853d1.webp";